import { h, Component, createRef } from "preact";

import { classNames, uniqueID } from "../helpers";
import Icon from "./Icon.jsx";

export default class TextField extends Component {
  ref = createRef();
  state = {
    value: null,
    revealed: false,
    focused: false,
  };

  handleInput = (event) => {
    // if (this.props.onChange)
    // return this.props.onChange(event.target.value, event);

    this.props.onInput && this.props.onInput(event.target.value);
  };

  handleFocus = () => {
    this.setState({ focused: true });
  };

  handleBlur = (event) => {
    this.setState({ focused: false });
    this.props.onBlur && this.props.onBlur(event);
  };

  toggleRevealClick = () => {
    this.setState({ revealed: !this.state.revealed });
  };

  componentDidMount() {
    M.updateTextFields();
    // Somehow safari overrides the spellcheck attribute, this seems to work
    if (this.props.spellcheck) {
      this.ref.current.setAttribute("spellcheck", this.props.spellcheck);
    }
  }

  static getDerivedStateFromProps({ uncontrolled, value }) {
    if (uncontrolled) {
      return {};
    }
    return {
      value,
    };
  }

  click() {
    this.ref.current.click();
  }

  render(props) {
    const { focused, revealed, value } = this.state;
    const id = props.id || props.name || uniqueID();

    return (
      <div
        class={classNames(
          "input-field text-field",
          props.class,
          props.slim && "text-field--slim",
          props.iconBefore && "text-field--with-icon",
          props.error && "text-field--invalid invalid",
          props.errorBorder && "text-field--invalid invalid",
          props.label && "text-field--with-label",
          props.inputPrefix && "text-field--with-prefix",
          focused && "text-field--focused"
        )}
      >
        {props.iconAfter && (
          <Icon class="text-field__suffixIcon">{props.iconAfter}</Icon>
        )}

        <input
          class="materialize-textarea"
          id={id}
          {...props}
          type={revealed ? "text" : props.type || "text"}
          value={value}
          ref={this.ref}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
        />
        {props.revealable ? (
          <i onClick={this.toggleRevealClick} class="icon">
            <span class="icon material-symbols-rounded is-password">
              visibility
            </span>
            <span class="icon material-symbols-rounded is-text">
              visibility_off
            </span>
          </i>
        ) : null}
        {props.expandable ? (
          <i class="icon">
            <span class="icon material-symbols-rounded">expand_more</span>
          </i>
        ) : null}
        {props.label && (
          <label for={id} class={!!value && "active"}>
            {props.label}
            {props.mandatory && "*"}
          </label>
        )}

        {props.inputPrefix && (
          <span class="text-field__inputPrefix">{props.inputPrefix}</span>
        )}
        {!props.error && props.info && (
          <span class="text-field__helper-text">{props.info}</span>
        )}
        {props.error && (
          <span class="text-field__helper-text">{props.error}</span>
        )}

        {props.iconBefore && (
          <Icon class="text-field__prefixIcon">{props.iconBefore}</Icon>
        )}
      </div>
    );
  }
}
